import React, { useEffect, useState } from "react";
import styled from "styled-components";
import TopNavbar from "../components/Nav/TopNavbar";
import { makePostRequest, makeGetRequest } from "../services/httpHelper";
import ErrorHandler from "../services/ErrorHandler";
import { toTitleCase } from "../utils/myFunctions";

export default function RequestDemoPage() {
  const [form, setForm] = useState({
    organization_name: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    message: "",
    product_id: "",
    captchaAnswer: "",
  });

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const [captcha, setCaptcha] = useState({ question: "", answer: 0 });

  useEffect(() => {
    const getProducts = async () => {
      const res = await makeGetRequest("products");
      if (res && res.errorType) {
        const errorMessage = ErrorHandler(res);
        console.log(errorMessage)
        setError("Something is wrong with server or Netowrk")
      } else {
        if (res.data && Array.isArray(res.data)) {
          setProducts(res.data);
        }
      }
    };

    const generateCaptcha = () => {
      const a = Math.floor(Math.random() * 10 + 1);
      const b = Math.floor(Math.random() * 10 + 1);
      setCaptcha({ question: `What is ${a} + ${b}?`, answer: a + b });
    };

    getProducts();
    generateCaptcha();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const requiredFields = Object.entries(form).every(
      ([key, val]) => key === "captchaAnswer" || val.trim() !== ""
    );
    if (!requiredFields) {
      setError("All fields are required.");
      setLoading(false);
      return;
    }

    if (parseInt(form.captchaAnswer, 10) !== captcha.answer) {
      setError("Incorrect answer to the math challenge.");
      setLoading(false);
      return;
    }

    const { captchaAnswer, ...formData } = form;

    try {
      const res = await makePostRequest("demo-request", formData);
      if (res && res.errorType) {
        const errorMessage = ErrorHandler(res);
        setError(errorMessage.toString());
        setLoading(false);
      } else if (res.data) {
        setSuccess(true);
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TopNavbar returnTo={true}/>
      <PageWrapper>
        <h1>Request a Demo</h1>
        <p>
          Fill in the form below and we’ll get in touch with a custom demo
          tailored to your needs.
        </p>

        {error && <ErrorText>{error}</ErrorText>}
        {success ? (
          <SuccessText>
            Thank you! Your request has been received. We'll be in touch soon.
          </SuccessText>
        ) : (
          <Form onSubmit={handleSubmit}>
            <input
              name="organization_name"
              placeholder="Organization Name"
              value={form.organization_name}
              onChange={handleChange}
            />
            <input
              name="contact_name"
              placeholder="Contact Name"
              value={form.contact_name}
              onChange={handleChange}
            />
            <input
              name="contact_email"
              type="email"
              placeholder="Contact Email"
              value={form.contact_email}
              onChange={handleChange}
            />
            <input
              name="contact_phone"
              placeholder="Contact Phone"
              value={form.contact_phone}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Briefly describe your interest or goals"
              value={form.message}
              onChange={handleChange}
            />
            <select name="product_id" value={form.product_id} onChange={handleChange}>
              <option value="">-- Select Product --</option>
              {products.map((prod) => (
                <option key={prod.id} value={prod.id}>
                  {toTitleCase(prod.name)}
                </option>
              ))}
            </select>
            <input
              name="captchaAnswer"
              placeholder={`Spam check: ${captcha.question}`}
              value={form.captchaAnswer}
              onChange={handleChange}
            />
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit Request"}
            </button>
          </Form>
        )}
      </PageWrapper>
    </>
  );
}

const PageWrapper = styled.div`
  max-width: 600px;
  margin: 40px auto;
  padding: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;

  input,
  textarea,
  select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
  }

  textarea {
    min-height: 100px;
  }

  button {
    background-color: purple;
    color: white;
    padding: 12px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }
`;

const ErrorText = styled.p`
  color: red;
`;

const SuccessText = styled.p`
  color: green;
`;
